// extracted by mini-css-extract-plugin
module.exports = {"flexParagraph":"App_flexParagraph__9PmDM","h2":"App_h2__1jX0b"};